import { z } from 'zod';
export const loginBodySchema = z.object({
    idToken: z.string().min(20).max(8192),
});
/** What the API returns after login and from GET /me (scope fields arrive in T07). */
export const meSchema = z.object({
    id: z.number().int().positive(),
    name: z.string(),
    email: z.string(),
    role: z.string(),
    permissions: z.array(z.string()),
    scope: z.object({
        type: z.enum(['global', 'cluster', 'facility', 'self']),
        clusterId: z.number().int().nullable(),
        facilityIds: z.array(z.number().int()),
    }),
});
export const bearerTokenSchema = z.object({
    token: z.string(),
    expiresAt: z.string(),
});
//# sourceMappingURL=auth.js.map